import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./footer.css";

const Footer = () => {
  return (
    <>
      {/* Footer Section */}
      <footer className="footer">
        <Container>
          {/* About Us */}
          <Row>
            <Col className="footer-about text-center mb-4">
              <h1>About Us</h1>
              <p>
                Shagan Arts specializes in custom signage and branding solutions
                for all your needs. Whether it's personalized gifts, neon
                boards, or custom prints, we've got you covered.
              </p>
            </Col>
          </Row>

          {/* Quick Links */}
          <Row>
            <Col md={12} className="footer-section text-center">
              <h1>Quick Links</h1>
              <ul className="footer-links d-inline-flex justify-content-center">
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/services">Services</Link>
                </li>
                <li>
                  <Link to="/contact">Contact Us</Link>
                </li>
              </ul>
            </Col>
          </Row>

          {/* Social Media */}
          <Row>
            <Col className="mb-4 social-icons text-center">
              <h1>Let's Connect</h1>
              <div className="social-icons">
                <a
                  href="https://wa.me/9814067069"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a
                  href="https://www.instagram.com/shagan.arts?igsh=YnJlczRkcnQ1cWZr"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="mailto:shaganarts@gmail.com">
                  <i className="fas fa-envelope"></i>
                </a>
              </div>
            </Col>
          </Row>

          {/* Copyright */}
          <Row>
            <Col className="text-center">
              <div className="footer-copyright">
                <span>
                  Copyright &copy; {new Date().getFullYear()} Shagan Arts. All
                  rights reserved.
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Footer;
